var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 48 48","fill":"currentColor"}},_vm.$listeners),[_c('path',{attrs:{"d":"M9 39h20V29h10V9H9v30zm0 3q-1.25 0-2.125-.875T6 39V9q0-1.25.875-2.125T9 6h30q1.25 0 2.125.875T42 9v21L30 42zm6-15v-3h8.5v3zm0-8v-3h18v3zM9 39V9v30z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }